module.exports = __webpack_public_path__ + "img/CellCycle-PDAC_GSE111672.3d070725.png";